import ButtonBox from '@/components/ui/ButtonBox';
import { KiaPage_Pagebuilder_Blocks_Tabs } from '@/graphql/generated/graphql';
import { m } from 'motion/react';
import { useState } from 'react';
import { containerVariants, viewPort } from 'utils/framer';
import { getContainerClass } from 'utils/helpers';
import Wysiwyg from '../components/dom-parser';

const TabsBlock = ({
  blockId,
  containerWidth,
  title,
  tabs,
}: KiaPage_Pagebuilder_Blocks_Tabs) => {
  if (!tabs?.length) return null;

  const [activeIndex, setActiveIndex] = useState(0);
  const activeTab = tabs[activeIndex];

  return (
    <section id={blockId ?? undefined} className="w-full my-14 lg:my-24">
      <div className={`w-full ${getContainerClass(containerWidth)}`}>
        {title && <h2 className="mb-5 lg:mb-10">{title}</h2>}

        <div className="flex flex-wrap gap-2.5 mb-5 lg:mb-10">
          {tabs.map((tab, i) => (
            <ButtonBox
              key={i}
              type={i === activeIndex ? 'default' : 'outline'}
              text={tab.label}
              onClick={() => setActiveIndex(i)}
            />
          ))}
        </div>

        <m.ul
          initial="hidden"
          whileInView="visible"
          viewport={viewPort}
          variants={containerVariants}
          className="editor flex flex-col lg:flex-row gap-6 lg:gap-[8%]"
        >
          {activeTab?.columns?.map((col, j) => (
            <m.li key={j} className="flex-1">
              <Wysiwyg>{col.content}</Wysiwyg>
            </m.li>
          ))}
        </m.ul>
      </div>
    </section>
  );
};

export default TabsBlock;
